import React from 'react';
import styled from 'astroturf/react';

import { Body } from 'js/design_system/Body';

const SocialProofContainer = styled(Body)`
  flex-shrink: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--text-secondary);
`;

type SocialProofLineProps = {
  /** The social-proof copy to display (AutotestFocusedNav `socialProofSlot`). */
  text: string;
};

/**
 * A small, additive live social-proof line shown next to the premium CTA for the
 * `v_social_proof` arm of nav_activation_2026_q2_v1 (lever C4). Renders nothing
 * outside that arm — the surface's CONTROL value is null, so `FocusedNavView`
 * never mounts this in control/other arms and rendering stays byte-identical.
 */
const SocialProofLine = ({ text }: SocialProofLineProps) => (
  <SocialProofContainer size="xs">{text}</SocialProofContainer>
);

export default SocialProofLine;
